// todo beautify :)

$(document).ready(function () {
    $('.js-search-submit').on('click', function() {
        $('#search-form').submit()
    })

    $('.js-search-header-submit').on('click', function() {
        $('#js-search-header-btn-submit').click()
    })

    /**
     * Show / Hide help Bar
     */
    $('.js-mob-help-bar').on('click', function () {
        $(this).addClass('show-help-block')
    });

// settings up click events
    $('.js-input-container').on('click', function (e) {
        if ($('#' + $(e.currentTarget).data('inputId'))) {
            $('#' + $(e.currentTarget).data('inputId')).focus()
        }
    })

// closing all other popups
    $('input').on('focus', function (e) {
        $('input').not(this).each((_, e) => {
            $('#' + $(e).data('popupId')).addClass('d-none')
        })

        if ($('#' + $(e.target).data('popupId')).data('canBeShown')) {
            $('#' + $(e.target).data('popupId')).removeClass('d-none')
        }
    })

//add keyword to input on click
    $('a').on('click', function (e) {
        if ($(e.target).data('inputId') && $('#' + $(e.target).data('inputId'))) {
            e.preventDefault()
           
            $('.search-input_sound_mobile').addClass('d-none')
            $('.js-set-new-value').removeClass('d-none')
            
            let arrValue = []
            let oldVal = $('.js-sound-value').val();
            let newOldVal = oldVal.split(', ')
            let newValue = e.target.innerText
            if (oldVal !== '') {
                newOldVal.some(value => value === newValue)
                ? $('.js-sound-value').val(oldVal)
                : $('.js-sound-value').val(oldVal + newValue.trim() + ', ')
            } else {
                $('.js-sound-value').val(e.target.text.trim() + ', ')
            }
            if($(`.js-set-new-value div:contains("${newValue}")`).length < 1) {
                arrValue.push(newValue)
                    $.each(arrValue, function( index, value ) {
                        let selectedSearchItem = $('<div class="d-flex align-items-baseline position-relative value-text" id="input-item"><p>' + value + 
                        '</p><img class="delete-input-item" src="images/icons/cross-black.png"></div>')
                        selectedSearchItem.on('click', function (e) {
                            const itemText = $(this).text()
                            const findValue = $(`p:contains('${itemText}')`)
                            findValue.css('background', '#fff')
                            findValue.children().attr('style', 'color: #000 !important')
                            $(this).remove()
                            if ($('.value-text').length < 1) {
                                $('.search-input_sound_mobile').removeClass('d-none')
                                $('.js-set-new-value').addClass('d-none')
                                $('#sound-mobile').val('')
                            }
                        })
                        selectedSearchItem.appendTo('.js-set-new-value')
                    })
                } else {
                    return
                }
            }
    })

// change background onClick
    $('.js-keyword-action-background').on('click', function (e) {
        $(this).css('background', '#49306b')
        $(this).children().attr('style', 'color: #fff !important')
    })

// listening btn cross to close current popup
    $('.popup-btn-close').on('click', function (e) {
        $('#' + e.currentTarget.dataset.parentId).addClass('d-none')
    })

// show modile search block
    $('#sound-input').on('click', function (e) {
        if ($(window).width() <= '995') {
            $('.js-search-form').addClass('d-none')
            $('.mobile-search-container').removeClass('d-none')
            $('#description-text').addClass('d-none')
            $('#h1-main-text').addClass('d-none')
        } else {
            $('.search-keyword_wrapper').removeClass('d-none')
        }
    })

 // close mobile and desktop popup
    $('#show-search-input').on('click', function (e) {
        let inputValue = $('#sound-mobile').val()
        $('#sound-input').val(inputValue)
        $('#header-keywords').val(inputValue)
        $('#description-text').removeClass('d-none')
            $('#h1-main-text').removeClass('d-none')
        $('.js-search-form').removeClass('d-none')
        $('.mobile-search-container').addClass('d-none')
    })

    $('#close-popup').on('click', function (e) {
        $('.search-keyword_wrapper').addClass('d-none')
    })

    $('#sound-mobile').on('click', function (e) {
        $('.search-keyword_wrapper_mobile').removeClass('d-none')
        $('.mobile-search-container').css('min-height','670px')
    })

    $('#close-btn').on('click', function (e) {
        $('.search-keyword_wrapper_mobile').addClass('d-none')
        $('.mobile-search-container').css('min-height','260px')
    })

// check for screen width to show background
    $(window).on('load', function() {
        if ($(window).width() <= '995'){
            $('#mobile-baner').removeClass('vh-100')
            $('#video-overlay-mobile').removeClass('position-absolute')
        }
    });

// mobile search button
    $(document).on('click', '.js-submit-app-search', function (e) {
        $('#header-search-form').submit()
    })

// close the popup when clicking anywhere in the document
    $(document).mouseup(function (e) {
        var container = $("#keywords-popup")
        if (container.has(e.target).length === 0){
            container.addClass('d-none')
        }
    });
// close the popup when clicking anywhere in the document (mobile)
    $(document).mouseup(function (e) {
        var container = $("#keywords-popup-modile")
        if (container.has(e.target).length === 0){
            container.addClass('d-none')
        }
    });
});
